import { createRouter, createWebHashHistory } from 'vue-router';
import { fr } from '@/components/forgerock';
import { useLoginStore } from '@/components/login.store';
import ErrorPage from './views/ErrorPage.vue';
import HomePage from './views/HomePage.vue';
import LoginPage from './views/LoginPage.vue';
import OTPPage from './views/OTPPage.vue';
import MarkUpdatedSessionPage from './views/MarkUpdatedSessionPage.vue';
import OathTokenVerifyPage from '@/views/OathTokenVerifyPage.vue';
import PasskeyPage from '@/views/PasskeyPage.vue';
import PasskeyPreRegistrationPage from '@/views/PasskeyPreRegistrationPage.vue';
import PostLoginPage from '@/views/PostLoginPage.vue';

// this pages will be loaded dynamically on demand to accelerate the main pages
const ConfirmPage = () => import('./views/ConfirmPage.vue');
const OathRegistrationInitPage = () => import('@/views/OathRegistrationInitPage.vue');
const OathRegistrationVerifierPage = () => import('@/views/OathRegistrationVerifierPage.vue');
//const InfoUsersNoRolePage = () => import('./views/InfoUsersNoRolePage.vue');
const LogoutPage = () => import('./views/LogoutPage.vue');

const routes = [
  { path: '/', name: 'home-page', component: HomePage },
  { path: '/confirm', name: 'set-pw-page', component: ConfirmPage },
  { path: '/login', name: 'login-page', component: LoginPage },
  { path: '/post-login', name: 'post-login', component: PostLoginPage },
  { path: '/passkey', name: 'passkey', component: PasskeyPage },
  { path: '/register-passkey', name: 'offer_passkey_reg', component: PasskeyPreRegistrationPage },
  { path: '/logout', name: 'logout-page', component: LogoutPage },
  { path: '/otp', name: 'otp-page', component: OTPPage },
  /// the OATH device registration was split in 2 because there are 2 auth-nodes that are displayed together
  { path: '/oath-register-init', name: 'OATH-Registration1', component: OathRegistrationInitPage },
  { path: '/oath-register', name: 'OATH-Registration2', component: OathRegistrationVerifierPage },
  { path: '/oath-token-verify', name: 'OATH-Token-Verifier', component: OathTokenVerifyPage },
  { path: '/auto-s-up', name: 'su-page', component: MarkUpdatedSessionPage },
  { path: '/error/:status([\\w_\\d]+)?', name: 'error', component: ErrorPage },
  { path: '/:pathMatch(.*)*', name: 'not-found', redirect: '/error/404' } // 404
];

const router = createRouter({
  history: createWebHashHistory(import.meta.env.BASE_URL),
  routes
});

router.beforeEach(async (to, _from) => {
  console.debug(`[SUI][router] to:${to.path}`);
  const store = useLoginStore();

  if (import.meta.env.VITE_DEBUG_MODE === to.name) {
    console.debug(`[SUI][router] DEBUG PAGE ${to.name as string} !!!`);
    return true;
  }

  // check if application was initialized
  if (!store.haveStep && to.name !== 'error') {

    store.saveAuthorizeInfo(new URLSearchParams(location.search));

    try {
      const session = await fr.getSessionInfo();

      if (session.realm !== '/consumer') {
        console.error(`[SUI] invalid realm: ${session.realm}`);
        return { path: '/error/loggedInDifferentRealm' };
      }
      console.info(`[SUI] session found on realm:${session.realm}. starting auth...`);
      store.existingSession = true;
      // after a login the SuccessUrl returned by FR will restart the OIDC flow (but redirect immediately with a code)
      return fr.initAuthentication();

    } catch (_e) {
      console.info(`[SUI] no existing session. starting auth...`);
      return fr.initAuthentication();
    }

  }

  return true;
});

export default router;
